export default {
  color: 'text',
  primary: {
    bg: 'teal.500',
    color: 'text',
  },
}
